import { SET_ENVIRONMENT_LOGO } from "../types.js";

export const acSuccess = (logo, type) => ({
    type,
    logo
});

export default (logo) => (dispatch) => {
    dispatch(acSuccess(logo, SET_ENVIRONMENT_LOGO));
}